var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bmui-field_paragraph",
      on: { click: _vm.mixinInputDoFocus }
    },
    [
      _c("div", { staticClass: "bmui-field_paragraph-wrap" }, [
        _c("p", { staticClass: "bmui-field_paragraph-title" }, [
          _vm._v(_vm._s(_vm.title || "TITLE")),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isNeed,
                  expression: "isNeed"
                }
              ],
              staticClass: "bmui-field_paragraph-isNeed"
            },
            [_vm._v("*")]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "bmui-field_paragraph-count" }, [
          _vm._v(
            _vm._s(_vm.valueInside.length) + "/" + _vm._s(_vm.maxlength || 100)
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "textarea",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueInside,
                expression: "valueInside"
              }
            ],
            ref: "input",
            staticClass: "bmui-field_paragraph-input",
            attrs: {
              placeholder: _vm.placeholder || "请输入",
              maxlength: _vm.maxlength || 100
            },
            domProps: { value: _vm.valueInside },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueInside = $event.target.value
              }
            }
          },
          "textarea",
          _vm.mixinInputProps,
          false
        )
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a778014a", { render: render, staticRenderFns: staticRenderFns })
  }
}